export const NOTIFICATION = [
  {
    title: "Delivery processing",
    time: "10 min.",
    boxColor: "primary",
    fontColor: "danger",
    url: `${process.env.PUBLIC_URL}/ecommerce/product`,
  },
  {
    title: "Order Complete",
    time: "1 hr",
    fontColor: "success",
    url: `${process.env.PUBLIC_URL}/ecommerce/order-history`,
  },
  {
    title: "Tickets Generated",
    time: "3 hr",
    fontColor: "secondary",
    url: `${process.env.PUBLIC_URL}/ecommerce/checkout`,
  },
  {
    title: "Delivery Complete",
    time: "6 hr",
    fontColor: "warning",
    url: `${process.env.PUBLIC_URL}/ecommerce/product-list`,
  },
];
